export default __webpack_public_path__ + "static/messages-flag-1c3a8df576acabd5eb4d5803da508e91.jpg";